"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SliderPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _logger = require("../../../services/logger");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Container = _styledComponents.default.div`
  width: 100%;
  padding: ${props => props.border ? '30px 30px' : '0 30px'};
  border: ${props => props.border && '1px solid #ddd;'};
  border-radius: 15px;
`;
const SliderContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  width: 100%;
  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      padding: 0px 40px;
    `)}
  span {
    align-self: center;
  }
`;
const LabelCell = _styledComponents.default.div`
  flex: 1;
`;
const LabelWrapper = _styledComponents.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: relative;
  align-items: center;
  ${_ref => {
  let {
    position
  } = _ref;
  return position === 'left' && (0, _styledComponents.css)`
      justify-content: flex-start;
      right: 20%;
    `;
}}
  ${_ref2 => {
  let {
    position
  } = _ref2;
  return position === 'right' && (0, _styledComponents.css)`
      justify-content: flex-end;
      left: 20%;
    `;
}}
`;
const renderSliderLabels = (title, position, testId) => /*#__PURE__*/_react.default.createElement(LabelWrapper, {
  position: position
}, /*#__PURE__*/_react.default.createElement(LabelCell, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
  size: 2,
  weight: 2,
  appearance: "secondary",
  dataAttributes: {
    'data-test-id': `slider-answer-title-${testId}`
  }
}, title)));
const mapItemsRangeLabels = items => {
  const showTopLabels = items.length === 3;
  let topLabels = {};
  if (showTopLabels) {
    const [left, center, right] = items;
    topLabels = {
      left: renderSliderLabels(left.title, 'left', 0),
      center: renderSliderLabels(center.title, '', 1),
      right: renderSliderLabels(right.title, 'right', 2),
      showTopLabels
    };
  }
  const rangeLabels = {};
  items.forEach((item, i) => {
    rangeLabels[i + 1] = {
      value: item.value,
      isDefault: item.isDefault
    };
  });
  return {
    rangeLabels,
    topLabels,
    showTopLabels
  };
};
const SliderPicker = _ref3 => {
  let {
    selected,
    label,
    onChange,
    items,
    border = false,
    sliderAppearance
  } = _ref3;
  const containerRef = (0, _react.useRef)();
  const [selectedValue, setSelectedValue] = (0, _react.useState)('0');
  const {
    rangeLabels,
    showTopLabels,
    topLabels
  } = mapItemsRangeLabels(items);
  (0, _react.useEffect)(() => {
    const selectedValues = Array.isArray(selected) ? selected : [selected];
    if (selectedValues.length) {
      const value = Object.keys(rangeLabels).find(key => rangeLabels[key].value === selectedValues[0]);
      if (value) setSelectedValue(value);
    }
  }, [selected]);
  (0, _react.useEffect)(() => {
    // remove tooltip
    const observer = new MutationObserver(() => {
      const element = document.querySelector('.rc-slider-tooltip');
      if (element) element.remove();
    });
    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true
      });
    }
    // add default selection to first value (start value of the slider)
    try {
      if (!selected || (selected === null || selected === void 0 ? void 0 : selected.length) === 0) {
        onChange({
          target: {
            value: Object.values(rangeLabels).find(item => item.isDefault).value
          }
        });
      }
    } catch (error) {
      _logger.Logger.error({
        segments: [_logger.Logger.LOGGER_SEGMENTS.QUESTIONNAIRE, _logger.Logger.LOGGER_SEGMENTS.COMPONENTS]
      })("Unable to set slider's default value");
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const appearanceStyle = sliderAppearance !== null && sliderAppearance !== void 0 ? sliderAppearance : 'primary';
  return /*#__PURE__*/_react.default.createElement(Container, {
    ref: containerRef,
    border: border
  }, /*#__PURE__*/_react.default.createElement(SliderContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.RangeSlider, {
    srLabel: {
      mainLabel: label || 'feature-slider'
    },
    value: selectedValue,
    onChange: v => {
      const value = rangeLabels[v].value;
      onChange({
        target: {
          value
        }
      });
    },
    min: 1,
    max: items.length,
    showDots: true,
    id: "slider-picker",
    rangeLabels: !showTopLabels && rangeLabels,
    topLabels: showTopLabels && topLabels,
    appearance: appearanceStyle
  })));
};
exports.SliderPicker = SliderPicker;
var _default = SliderPicker;
exports.default = _default;